import { on } from '@ember/modifier';
import { htmlSafe } from '@ember/template';
import { PhCheckCircle, PhPencilSimple, PhXCircle } from 'ember-phosphor-icons';
import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { eq } from 'tio-ui/utilities';

interface CompletedStepSummarySignature {
  Args: {
    stepNumber: number;
    label: string;
    summary: string;
    summaryKind?: 'course-cash';
    isComplete: boolean;
    onEdit: () => void;
  };
  Element: HTMLButtonElement;
}

const CompletedStepSummary: TOC<CompletedStepSummarySignature> = <template>
  <button
    type="button"
    class="border-b tio-border-default pb-8 flex items-center justify-between w-full text-left cursor-pointer group"
    aria-label={{t "tas.guided.edit_step" step=@label}}
    {{on "click" @onEdit}}
    ...attributes
  >
    <div class="flex items-center gap-2">
      {{#if @isComplete}}
        <PhCheckCircle @size="24" @weight="fill" class="tio-fg-info shrink-0" />
      {{else}}
        <span
          class="inline-flex items-center justify-center w-6 h-6 rounded-full bg-error-50 ring-2 ring-error-100 shrink-0"
        >
          <PhXCircle @size="24" @weight="fill" class="text-error-600" />
        </span>
      {{/if}}
      <span
        class="font-semibold
          {{if @isComplete 'tio-fg-muted' 'text-error-700'}}
          group-hover:tio-fg-brand transition-colors"
      >{{@label}}</span>
    </div>
    <div class="flex items-center gap-6">
      {{#if @summary}}
        <span
          class="font-medium
            {{if @isComplete 'tio-fg-primary' 'text-error-700'}}
            text-right truncate max-w-[200px]"
        >
          {{#if (eq @summaryKind "course-cash")}}
            <span aria-hidden="true">{{htmlSafe (t "common.tas.course_cash.default")}}</span>
            <span class="sr-only">{{t "common.tas.course_cash.label"}}</span>
          {{else}}
            {{@summary}}
          {{/if}}
        </span>
      {{/if}}
      <span class="tio-fg-disabled group-hover:tio-fg-brand transition-colors">
        <PhPencilSimple @size="18" />
      </span>
    </div>
  </button>
</template>;

export default CompletedStepSummary;
